import _ from 'lodash';
import { ConfirmComponent } from './confirm.component';
import { TicketType } from '../../ticket.constants';
import { FinanceTypes } from '../../../../common/ui/confirmFinances/confirmFinances.constants';

export const confirmStateName = 'app.ticket.confirm';

export const confirmState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: confirmStateName,
    url: '/confirm',
    component: ConfirmComponent.name,
    data: { requiresAuth: true },
    resolve,
  });
};

const resolve = {
  data: ($q, ticketService, cardService, ticketId) => {
    'ngInject';

    const defer = $q.defer();
    const ticketType = TicketType.Receiving;

    ticketService.fetchTransactions(ticketType, ticketId).then((partners) => {
      // Remove obsolete standingOrders/scheduledTransactions
      delete partners['standingOrders'];
      delete partners['scheduledTransactions'];

      cardService.resetCards();

      let cards = {};
      _.keys(partners).forEach((type) => {
        // Filter out all partners missing their name
        cards[type] = _.filter(partners[type], (p) => !!p.name).map(
          (p, idx) => {
            // Set index per type as id and set related ticketId
            p.id = idx;
            p.ticketId = ticketId;

            // HOTFIX ensure that we have a partner object at this point
            if (!p.partner) {
              p.partner = {};
            }

            // TODO This task should definitely have been done by backend, time will tell...
            switch (type) {
              case FinanceTypes.directDebits.id: {
                cardService.prepareDirectDebit(p);
                break;
              }
              case FinanceTypes.receivedPayments.id: {
                cardService.prepareReceivedPayment(p);
                break;
              }
              case FinanceTypes.standingOrders.id: {
                cardService.prepareStandingOrder(p);
                break;
              }
            }
            return cardService.buildPaymentPartnerCard(p);
          },
        );
      });

      defer.resolve({
        cards,
        partners,
      });
    });

    return defer.promise;
  },
};
